import util from '@bmp-vue/core/api/util';

const controller = 'Clients';
export default Object.assign({}, util.GetCrud(controller, ['getall', 'post', 'put', 'persist']));
